import { isEqual, cloneDeep } from "lodash"
import { buildGeocodeUrl } from '../../../utils/helpers'

// workaround to managing comparison where auto-calculated dates
// are triggering inequality between initial and current values
export const isChanged = (initial, values) => {
    let original = cloneDeep(initial)
    let current = cloneDeep(values)

    original.sub_jobs.forEach((obj) => {
        if (obj.pebble_details) {
            obj.pebble_details.scheduled_app_date = null
            obj.pebble_details.prep_date = null
            obj.pebble_details.detail_date = null
        }
    })

    current.sub_jobs.forEach((obj) => {
        if (obj.pebble_details) {
            obj.pebble_details.scheduled_app_date = null
            obj.pebble_details.prep_date = null
            obj.pebble_details.detail_date = null
        }
    })

    return !isEqual(original, current)
}

export const shouldGetTemporaryLatLon = (model)=>{
    return !model.lat && !model.lon && !model.temp_lat && !model.temp_lon && model.address_line_1 && model.state
}

export const getTempLatLon = async (model) => {
    //Get Approximate Lat and Lon for unverified addresses on save
    const url = buildGeocodeUrl(model.address_line_1, model.city, model.state, model.county, model.zip_code)
    const response = await fetch(url)
    const results = await response.json()

    if (results?.results?.length > 0) {
        model.temp_lat = results.results[0].geometry.location.lat
        model.temp_lon =results.results[0].geometry.location.lng
    }
    return model
}